<div class="form-modal">
    <div class="form-modal__body">

        <a tabindex="0" (click)="onClose()" (keypress)="onClose()" class="close-modal"
            aria-label="Close organization edit form">
            <img src="./assets/img/icons-svg/close-icon.svg">
        </a>
        <div class="img-wrapper">
            <div class="clearfix"></div>
            <div class="title-wrapper">
                <h1>Create Permission</h1>
            </div>
        </div>
        <popup-loader *ngIf="isloaded"></popup-loader>
        <div class="form-wrapper">
            <form
                novalidate
                [formGroup]="createPermissionForm"
                (ngSubmit)="doSave()"
            >
                <div class="app-c-form-group">
                    <label class="app-c-form--label" for="PermissionName">Permission Name</label>
                    <input class="app-c-form-control" type="text" id="PermissionName" formControlName="PermissionName" />
                    <div class="error-message" *ngIf="isSubmitted && createPermissionForm.get('PermissionName').hasError('required')">
                        Permission Name is required
                    </div>
                </div>
                <div class="app-c-form-group">
                    <label class="app-c-form--label" for="Permission">Permission Key</label>
                    <input class="app-c-form-control" type="text" id="Permission" formControlName="Permission" />
                    <div class="error-message" *ngIf="isSubmitted && createPermissionForm.get('Permission').hasError('required')">
                        Permisison key is required
                    </div>
                </div>

                <div class="fixed-footer">
                    <button tabindex="0" class="btn-primary btn">
                        Save
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>
